/* Mania de Mulher — carrosseis + animacoes de entrada com stagger (idempotente) */
(function () {
  function initCarousel(root) {
    if (root.dataset.mmInit) return;
    root.dataset.mmInit = '1';
    var track = root.querySelector('[data-mm-track]');
    if (!track) return;
    var items = track.children;
    if (!items.length) return;
    var prev = root.querySelector('[data-mm-prev]');
    var next = root.querySelector('[data-mm-next]');
    var dots = root.querySelector('[data-mm-dots]');
    var per = parseInt(root.getAttribute('data-mm-per') || '4', 10);
    var gap = parseInt(root.getAttribute('data-mm-gap') || '24', 10);
    var index = 0;

    /* distancia real entre dois cards: respeita o gap do CSS em cada breakpoint */
    function stepSize() {
      if (items.length > 1) {
        var d = items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        if (d > 0) return d;
      }
      return items[0].getBoundingClientRect().width + gap;
    }

    /* quantos cards cabem de fato na janela do carrossel (medido, nao chutado por breakpoint) */
    function perView() {
      var vp = track.parentElement;
      var vw = vp ? vp.getBoundingClientRect().width : 0;
      var s = stepSize();
      if (!vw || !s) return Math.min(per, items.length);
      var n = Math.round(vw / s);
      if (n < 1) n = 1;
      if (n > items.length) n = items.length;
      return Math.min(n, per);
    }

    function maxIndex() { return Math.max(0, items.length - perView()); }

    function render() {
      if (index > maxIndex()) index = maxIndex();
      if (index < 0) index = 0;
      track.style.transform = 'translateX(' + (-index * stepSize()) + 'px)';
      if (dots) {
        var pages = maxIndex() + 1;
        var h = '';
        for (var i = 0; i < pages; i++) h += '<button class="' + (i === index ? 'mm-active' : '') + '" data-i="' + i + '" aria-label="Página ' + (i + 1) + '"></button>';
        dots.innerHTML = h;
        Array.prototype.forEach.call(dots.children, function (b) { b.onclick = function () { index = parseInt(b.getAttribute('data-i'), 10); render(); }; });
      }
      if (prev) prev.classList.toggle('mm-disabled', index <= 0);
      if (next) next.classList.toggle('mm-disabled', index >= maxIndex());
    }

    if (prev) prev.onclick = function () { index--; render(); };
    if (next) next.onclick = function () { index++; render(); };
    root._mmRender = render;
    render();
    /* recalcula depois que fontes/imagens assentam */
    window.addEventListener('load', render);
    if (root.getAttribute('data-mm-autoplay') === 'true') {
      setInterval(function () { index = index >= maxIndex() ? 0 : index + 1; render(); }, parseInt(root.getAttribute('data-mm-interval') || '5500', 10));
    }
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-mm-carousel]').forEach(initCarousel); }
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.mm-reveal:not(.mm-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mm-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (s) { return s.classList && s.classList.contains('mm-reveal'); }) : [];
          var idx = Math.max(0, sibs.indexOf(el));
          el.style.animationDelay = (idx % 4 * 90) + 'ms';
          el.classList.add('mm-in');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() { initAll(document); reveal(document); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('resize', function () { document.querySelectorAll('[data-mm-carousel]').forEach(function (r) { if (r._mmRender) r._mmRender(); }); });
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-mm-carousel]').forEach(function (r) { r.dataset.mmInit = ''; }); initAll(e.target); reveal(e.target); });
})();
